module.exports = __webpack_public_path__ + "static/img/5.a6b13ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/5.png
// module id = CGru
// module chunks = 0